<section class="footer-legal" aria-label="Legal policies and terms">
  <h3 class="footer-legal__heading">Policies &amp; Terms</h3>
  <p class="footer-legal__subheading">
    Important information about how we handle your data, deliver orders, and process refunds.
  </p>

  <div class="footer-legal__stack">
    <details class="footer-legal__panel">
      <summary>Privacy Policy</summary>
      <div class="footer-legal__body">
        <div class="footer-legal__section">
          <h4 class="footer-legal__section-title">Read the full policy</h4>
          <p class="footer-legal__text">
            Our Privacy Policy is published at a public URL so anyone, including search engines and
            platform reviewers, can read it without logging in:
            <a routerLink="/privacy" href="/privacy">https://unaavu.com/privacy</a>.
            Facebook Login details are at
            <a routerLink="/privacy/facebook" href="/privacy/facebook">https://unaavu.com/privacy/facebook</a>.
          </p>
        </div>
        <div class="footer-legal__section">
          <h4 class="footer-legal__section-title">Introduction</h4>
          <p class="footer-legal__text">
            This Privacy Policy describes how House of Meghsaroj and its affiliates (collectively "Company", "we", "our", "us")
            collect, use, share, protect or otherwise process your information and personal data through our website
            <a href="https://unaavu.com" target="_blank" rel="noopener noreferrer">https://unaavu.com</a>
            (hereinafter referred to as the Platform).
          </p>
          <p class="footer-legal__text">
            Please note that you may be able to browse certain sections of the Platform without registering with us.
            We do not offer any product or service under this Platform outside India and your personal data will
            primarily be stored and processed in India.
          </p>
          <p class="footer-legal__text">
            By visiting this Platform, providing your information or availing any product or service offered on the
            Platform, you expressly agree to be bound by the terms and conditions of this Privacy Policy, the Terms
            of Use and the applicable service or product terms and conditions, and agree to be governed by the laws
            of India including but not limited to the laws applicable to data protection and privacy. If you do not
            agree, please do not use or access our Platform.
          </p>
        </div>

        <div class="footer-legal__section">
          <h4 class="footer-legal__section-title">Collection</h4>
          <p class="footer-legal__text">
            We collect your personal data when you use our Platform, services or otherwise interact with us during
            the course of our relationship and related information provided from time to time. Some of the
            information that we may collect includes but is not limited to personal data or information provided to
            us during sign-up, registering or using our Platform such as name, date of birth, address, telephone or
            mobile number, email ID and/or any such information shared as proof of identity or address.
          </p>
          <p class="footer-legal__text">
            Some of the sensitive personal data may be collected with your consent, such as your bank account or
            credit or debit card or other payment instrument information or biometric information such as your facial
            features or physiological information (in order to enable use of certain features when opted for,
            available on the Platform), all of the above being in accordance with applicable law(s). You always have
            the option to not provide information, by choosing not to use a particular service or feature on the
            Platform.
          </p>
          <p class="footer-legal__text">
            We may track your behaviour, preferences, and other information that you choose to provide on our
            Platform. This information is compiled and analysed on an aggregated basis. We will also collect your
            information related to your transactions on the Platform and such third-party business partner platforms.
            When such a third-party business partner collects your personal data directly from you, you will be
            governed by their privacy policies.
          </p>
          <p class="footer-legal__text">
            We shall not be responsible for the third party business partner's privacy practices or the content of
            their privacy policies, and we request you to read their privacy policies prior to disclosing any
            information. If you receive an email or a call from a person or association claiming to be seeking any
            personal data like debit or credit card PIN, net-banking or mobile banking password, we request you to
            never provide such information. If you have already revealed such information, report it immediately to an
            appropriate law enforcement agency.
          </p>
        </div>

        <div class="footer-legal__section">
          <h4 class="footer-legal__section-title">Usage</h4>
          <p class="footer-legal__text">
            We use personal data to provide the services you request. To the extent we use your personal data to
            market to you, we will provide you the ability to opt-out of such uses.
          </p>
          <p class="footer-legal__text">
            We use your personal data to assist sellers and business partners in handling and fulfilling orders;
            enhancing customer experience; to resolve disputes; troubleshoot problems; inform you about online and
            offline offers, products, services, and updates; customise your experience; detect and protect us
            against error, fraud and other criminal activity; enforce our terms and conditions; conduct marketing
            research, analysis and surveys; and as otherwise described to you at the time of collection of
            information. You understand that your access to these products or services may be affected in the event
            permission is not provided to us.
          </p>
        </div>

        <div class="footer-legal__section">
          <h4 class="footer-legal__section-title">Sharing</h4>
          <p class="footer-legal__text">
            We may share your personal data internally within our group entities, our other corporate entities, and
            affiliates to provide you access to the services and products offered by them. These entities and
            affiliates may market to you as a result of such sharing unless you explicitly opt-out.
          </p>
          <p class="footer-legal__text">
            We may disclose personal data to third parties such as sellers, business partners, third party service
            providers including logistics partners, prepaid payment instrument issuers, third-party reward programs
            and other payment methods opted by you. These disclosures may be required for us to provide you access
            to our services and products, to comply with our legal obligations, to enforce our user agreement, to
            facilitate our marketing and advertising activities, and to prevent, detect, mitigate, and investigate
            fraudulent or illegal activities related to our services.
          </p>
          <p class="footer-legal__text">
            We may disclose personal and sensitive personal data to government agencies or other authorised law
            enforcement agencies if required to do so by law or in the good faith belief that such disclosure is
            reasonably necessary to respond to subpoenas, court orders, or other legal process. We may disclose
            personal data to law enforcement offices, third party rights owners, or others in the good faith belief
            that such disclosure is reasonably necessary to enforce our Terms of Use or Privacy Policy; respond to
            claims that content violates the rights of a third party; or protect the rights, property or personal
            safety of our users or the general public.
          </p>
        </div>

        <div class="footer-legal__section">
          <h4 class="footer-legal__section-title">Security Precautions</h4>
          <p class="footer-legal__text">
            To protect your personal data from unauthorised access or disclosure, loss or misuse we adopt reasonable
            security practices and procedures. Once your information is in our possession or whenever you access your
            account information, we adhere to our security guidelines to protect it against unauthorised access and
            offer the use of a secure server.
          </p>
          <p class="footer-legal__text">
            However, the transmission of information is not completely secure for reasons beyond our control. By using
            the Platform, users accept the security implications of data transmission over the internet which cannot
            always be guaranteed as completely secure. Users are responsible for ensuring the protection of login and
            password records for their account.
          </p>
        </div>

        <div class="footer-legal__section">
          <h4 class="footer-legal__section-title">Data Deletion and Retention</h4>
          <p class="footer-legal__text">
            You have an option to delete your account by visiting your profile and settings on our Platform. This
            action would result in you losing all information related to your account. You may also write to us at
            the contact information provided below to assist you with these requests.
          </p>
          <p class="footer-legal__text">
            We may refuse or delay deletion of the account in event of any pending grievance, claims, pending
            shipments or any other services. Once the account is deleted, you will lose access to the account. We
            retain your personal data for a period no longer than is required for the purpose for which it was
            collected or as required under any applicable law. However, we may retain data if we believe it may be
            necessary to prevent fraud or future abuse or for other legitimate purposes. We may continue to retain
            your data in anonymised form for analytical and research purposes.
          </p>
        </div>

        <div class="footer-legal__section">
          <h4 class="footer-legal__section-title">Your Rights &amp; Consent</h4>
          <p class="footer-legal__text">
            You may access, rectify, and update your personal data directly through the functionalities provided on
            the Platform. By visiting our Platform or by providing your information, you consent to the collection,
            use, storage, disclosure and otherwise processing of your information in accordance with this Privacy
            Policy.
          </p>
          <p class="footer-legal__text">
            You consent to us (including our corporate entities, affiliates, lending partners, technology partners,
            marketing channels, business partners and other third parties) contacting you through SMS, instant
            messaging apps, call and/or e-mail for the purposes specified in this Privacy Policy. You may withdraw
            consent by writing to the Grievance Officer with the subject line "Withdrawal of consent for processing
            personal data". Withdrawal will not be retrospective. We reserve the right to restrict or deny services
            for which such information is necessary.
          </p>
        </div>

        <div class="footer-legal__section">
          <h4 class="footer-legal__section-title">Facebook Login</h4>
          <p class="footer-legal__text">
            If you sign in with Facebook, see our dedicated
            <a href="/privacy/facebook">Facebook Login Privacy Policy</a>
            for details on what we collect, how we use it, and how to request data deletion.
          </p>
        </div>

        <div class="footer-legal__section">
          <h4 class="footer-legal__section-title">Changes to this Privacy Policy</h4>
          <p class="footer-legal__text">
            Please check our Privacy Policy periodically for changes. We may update this Privacy Policy to reflect
            changes to our information practices and may alert you about significant changes as required under
            applicable laws.
          </p>
          <div class="footer-legal__contact">
            <p><strong>Grievance Officer: Meghraj Marothi</strong></p>
            <p>Unaavu, Plot No 12, Krishna Nagar, Panch batti Airforce, Defence Lab Road Ratanada, Jodhpur, Rajasthan. 342001</p>
            <p>Email: <a href="mailto:unaavukitchen@gmail.com">unaavukitchen@gmail.com</a></p>
            <p>Phone: <a href="tel:+918824867154">+91 8824867154</a></p>
          </div>
        </div>
      </div>
    </details>

    <details class="footer-legal__panel">
      <summary>Terms &amp; Conditions</summary>
      <div class="footer-legal__body">
        <div class="footer-legal__section">
          <h4 class="footer-legal__section-title">Electronic Record</h4>
          <p class="footer-legal__text">
            This document is an electronic record in terms of Information Technology Act, 2000 and rules thereunder as
            applicable. This electronic record is generated by a computer system and does not require any physical or
            digital signatures. It is published in accordance with Rule 3 (1) of the Information Technology
            (Intermediaries guidelines) Rules, 2011 for access or usage of
            <a href="https://unaavu.com" target="_blank" rel="noopener noreferrer">https://unaavu.com</a>
            ("Website"), including the related mobile site and mobile application (the "Platform").
          </p>
          <p class="footer-legal__text">
            The Platform is owned by House of Meghsaroj, a company incorporated under the Companies Act, 1956 with its registered
            office at Plot No 12, Krishna Nagar, Panch batti Airforce, Defence Lab Road Ratanada, Jodhpur, Rajasthan. 342001 (hereinafter "Platform Owner", "we", "us", "our").
          </p>
        </div>

        <div class="footer-legal__section">
          <h4 class="footer-legal__section-title">Agreement to Terms</h4>
          <p class="footer-legal__text">
            Your use of the Platform and services are governed by these Terms of Use including applicable policies
            incorporated by reference. By mere use of the Platform, you contract with the Platform Owner and these
            terms constitute your binding obligations. These Terms relate to your use of our website, goods or
            services (collectively, "Services"). Conflicting terms proposed by you are expressly rejected.
          </p>
          <p class="footer-legal__text">
            These Terms of Use can be modified at any time without assigning any reason. It is your responsibility to
            periodically review them. "You", "your" or "user" means any natural or legal person who has agreed to
            become a user or buyer on the Platform.
          </p>
          <p class="footer-legal__text">
            <strong>
              Accessing, browsing or otherwise using the Platform indicates your agreement to all terms and conditions
              under these Terms of Use. Please read carefully before proceeding.
            </strong>
          </p>
        </div>

        <div class="footer-legal__section">
          <h4 class="footer-legal__section-title">Use of Services</h4>
          <ul class="footer-legal__list">
            <li>
              You agree to provide true, accurate and complete information during and after registration, and you are
              responsible for all acts done through your registered account.
            </li>
            <li>
              Neither we nor any third parties provide any warranty as to the accuracy, timeliness, performance,
              completeness or suitability of information offered on this website or through the Services.
            </li>
            <li>
              Your use of our Services and the Platform is solely at your own risk and discretion. You must
              independently assess that the Services meet your requirements.
            </li>
            <li>
              Platform contents are proprietary to us. Unauthorized use may lead to action under these Terms and/or
              applicable laws.
            </li>
            <li>You agree to pay charges associated with availing the Services.</li>
            <li>
              You agree not to use the Platform for any unlawful, illegal or forbidden purpose under these Terms or
              applicable Indian or local laws.
            </li>
            <li>
              The website may contain links to third party websites governed by their own terms and privacy policies.
            </li>
            <li>
              Upon initiating a transaction, you enter into a legally binding contract with the Platform Owner for
              the Services.
            </li>
          </ul>
        </div>

        <div class="footer-legal__section">
          <h4 class="footer-legal__section-title">Indemnity &amp; Limitation of Liability</h4>
          <p class="footer-legal__text">
            You shall indemnify and hold harmless Platform Owner, its affiliates, group companies and their respective
            officers, directors, agents, and employees from any claim, demand, or actions including reasonable
            attorneys' fees arising out of your breach of these Terms, Privacy Policy or other Policies, or violation
            of any law or third party rights.
          </p>
          <p class="footer-legal__text">
            In no event will the Platform Owner be liable for any indirect, consequential, incidental, special or
            punitive damages arising from use of or inability to use the Services, exceeding the amount paid by you
            for the Services giving rise to the cause of action or Rupees One Hundred (Rs. 100), whichever is less.
          </p>
        </div>

        <div class="footer-legal__section">
          <h4 class="footer-legal__section-title">Governing Law &amp; Jurisdiction</h4>
          <p class="footer-legal__text">
            Parties shall not be liable for failure to perform obligations prevented or delayed by force majeure.
            These Terms shall be governed by the laws of India. All disputes shall be subject to the exclusive
            jurisdiction of the courts in Jodhpur, Rajasthan.
          </p>
          <div class="footer-legal__contact">
            <p><strong>Contact</strong></p>
            <p>Unaavu, Plot No 12, Krishna Nagar, Panch batti Airforce, Defence Lab Road Ratanada, Jodhpur, Rajasthan. 342001</p>
            <p>Email: <a href="mailto:unaavukitchen@gmail.com">unaavukitchen@gmail.com</a></p>
          </div>
        </div>
      </div>
    </details>

        <details class="footer-legal__panel">
      <summary>Shipping Policy</summary>
      <div class="footer-legal__body">
        <div class="footer-legal__section">
          <h4 class="footer-legal__section-title">Processing Time</h4>
          @if (shippingBody(); as shipping) {
            @for (paragraph of paragraphs(shipping); track paragraph) {
              <p class="footer-legal__text">{{ paragraph }}</p>
            }
          } @else {
            <p class="footer-legal__text">
              All orders are delivered within 4–5 business hours.
            </p>
          }
        </div>
      </div>
    </details>

    <details class="footer-legal__panel">
      <summary>Return &amp; Refund Policy</summary>
      <div class="footer-legal__body">
        @if (returnsBody(); as returns) {
          <div class="footer-legal__section">
            <h4 class="footer-legal__section-title">Policy</h4>
            @for (paragraph of paragraphs(returns); track paragraph) {
              <p class="footer-legal__text">{{ paragraph }}</p>
            }
          </div>
        } @else {
        <div class="footer-legal__section">
          <h4 class="footer-legal__section-title">Returns</h4>
          <p class="footer-legal__text">No returns are allowed.</p>
        </div>

        <div class="footer-legal__section">
          <h4 class="footer-legal__section-title">Refunds</h4>
          <p class="footer-legal__text">No refunds are allowed on food orders.</p>
          <p class="footer-legal__text">
            For reservations, you will get a refund of the cover charge already paid less 10% if you cancel your
            reservation more than 2 hours before the check-in time. If you cancel after that, or for no shows, there
            will be no refund.
          </p>
          <p class="footer-legal__text">
            Refund will be credited back to you via your original payment mode in 4-5 business days.
          </p>
        </div>
        }
      </div>
    </details>
    <details class="footer-legal__panel">
      <summary>Cookies Policy</summary>
      <div class="footer-legal__body">
        <div class="footer-legal__section">
          <h4 class="footer-legal__section-title">What we use</h4>
          <p class="footer-legal__text">
            We use cookies and similar technologies (including local storage) so you can browse the menu, keep items
            in your cart, stay signed in, track an order, and complete checkout. Some cookies are essential for the
            site to work.
          </p>
          <p class="footer-legal__text">
            If you sign in with Facebook or Instagram, those providers may set their own cookies. Payment partners
            and maps may also set cookies when you use those features.
          </p>
        </div>
        <div class="footer-legal__section">
          <h4 class="footer-legal__section-title">Your choices</h4>
          <p class="footer-legal__text">
            You can block or delete cookies in your browser. Disabling essential cookies may stop login, cart, and
            live order tracking from working. Read the full
            <a routerLink="/cookies">Cookies Policy</a>.
          </p>
        </div>
      </div>
    </details>
  </div>
</section>
